import flightEpic from './FlightDetailsEpic';
import { combineEpics } from 'redux-observable';
import FlightTrafficEpics from '../components/FlightTraffic/FlightTraffic.epics';
import FlightEditEpics from '../components/FlightEdit/FlightEdit.epics';
import FlightCompositionEpics from '../components/Composition/Composition.epics';
export const rootEpic = combineEpics(flightEpic, FlightTrafficEpics, FlightEditEpics, FlightCompositionEpics);
export default rootEpic;

//# sourceMappingURL=epics.js.map
